"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Used as a container for `CardTitle` and `CardSubtitle` components.
 */


var CardHeader = function CardHeader(_ref) {
  var avatar = _ref.avatar,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["avatar", "className", "children"]);

  return _react2.default.createElement("section", _extends({
    className: (0, _classnames2.default)("mdc-card__primary", {
      "mdc-card__primary--avatar": avatar
    }, className)
  }, other), children);
};

CardHeader.propTypes = {
  /** Header contains an avatar */
  avatar: _propTypes.bool
};
exports.default = CardHeader;